import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { ActivityIndicator } from 'react-native-web';
import { useTranslation } from 'react-i18next';
import { View, StyleSheet, ScrollView, TouchableOpacity, Image, Linking } from 'react-native';
import { useDispatch } from 'react-redux';
import BaseText from '../components/BaseText';
import Button from '../components/Button';
import InputForm from '../components/InputForm';
import { Modals } from '../constants/ScreenNames';
import { i18nNS, useComponentTKey } from '../i18n';
import { CommonProperties, CommonStyles, Color, FontSize } from '../styles';
import { getRebookPassengers } from '../store/actions/mytrips';
import RebookFooter from '../components/RebookFooter';
const RebookScreen = () => {
  const [lastName, setLastName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [confirmationNumber, setConfirmationNumber] = useState('');
  const dispatch = useDispatch();
  const { t } = useTranslation(i18nNS.login);
  const { tKey } = useComponentTKey('LoginScreen');
  const navigation = useNavigation();

  const isValid = () => {
    const _errorMessages = {};
    if (!lastName) {
      _errorMessages.lastName = t('common:Error.requiredLastName');
    }
    if (!confirmationNumber) {
      _errorMessages.confirmationNumber = t('common:Error.requiredConfirmation');
    }
    setErrorMessages(_errorMessages);
    return Object.keys(_errorMessages).length === 0;
  };

  const onPressSubmit = async () => {
    if (!isValid()) {
      return;
    } else {
      setIsLoading(true);
      await dispatch(getRebookPassengers(lastName, confirmationNumber));
      setIsLoading(false);
    }
  };

  const showModal = () => {
    navigation.navigate(Modals.RebookModal);
  };
  return (
    <ScrollView
      keyboardShouldPersistTaps="always"
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
    >
      <View style={styles.body}>
        <View style={styles.center}>
          <Image
            style={styles.headerLogoImg}
            source={require('../assets/img/icons/logo-home.png')}
          />
        </View>
        <View style={styles.heading}>
          <BaseText style={styles.textHeading}>Rebook on TripEasy</BaseText>
        </View>
        <View style={styles.rebookBox}>
          <BaseText style={styles.rebookText}>
            Frontier sincerely apologizes for your recent flight cancellation. Please utilize this
            TripEasy webpage to make your booking on an alternative airline. Frontier will reimburse
            you up to the amount specified on the letter you received. A check* will be sent to the
            address specified during this booking and may take up to 14 business days for processing
            and mailing.
          </BaseText>
          <BaseText style={styles.frontierHeading}>Frontier Rebooking Information</BaseText>
          <View style={styles.form}>
            <InputForm
              placeholder={t(tKey('EnterLastName'))}
              errorMessage={errorMessages.lastName}
              value={lastName}
              onChangeText={(e) => setLastName(e)}
            />
            <InputForm
              placeholder={t(tKey('EnterConfirmationNumber'))}
              errorMessage={errorMessages.confirmationNumber}
              value={confirmationNumber}
              onChangeText={(e) => setConfirmationNumber(e)}
            />
            <TouchableOpacity onPress={showModal}>
              <BaseText style={styles.confirmationText}>
                Where can I find my confirmation number?
              </BaseText>
            </TouchableOpacity>

            <Button
              label={t('common:Submit')}
              color={Color.corporate}
              style={styles.submitButton}
              labelStyle={CommonStyles.h2}
              onPress={onPressSubmit}
            />
          </View>
        </View>
        <View style={styles.headingBottom}>
          <BaseText>
            *The amount of the reimbursement check you receive will reflect the amount of the other
            airline ticket purchased through this tripeasy site less any refunds of your original
            Frontier purchase (fare and ancillaries). Total reimbursement between any refunds and
            the reimbursement check will be up to the maximum amount that was stated on the
            cancellation letter you received or the purchase amount of the other airline ticket,
            whichever is less.
          </BaseText>
        </View>
        <RebookFooter />
        {isLoading && (
          <View style={styles.loading}>
            <ActivityIndicator size="large" color={Color.primary} />
          </View>
        )}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  center: {
    justifyContent: 'center',
    alignItems: 'center',
    ...CommonProperties.p2,
  },
  body: {
    alignContent: 'stretch',
    alignItems: 'center',
    marginTop: 0,
    marginBottom: 0,
    ...CommonProperties.p5,
  },
  headerLogoImg: {
    height: 35,
    width: 250,
    resizeMode: 'contain',
  },
  heading: {
    marginBottom: 60,
    alignItems: 'center',
    width: '115%',
    ...CommonProperties.p5,
    backgroundColor: Color.lightgray,
  },
  headingBottom: {
    marginTop: 10,
    alignItems: 'center',
    width: '115%',
    ...CommonProperties.p5,
    backgroundColor: Color.lightgray,
  },
  textHeading: {
    fontSize: FontSize.h1,
    fontWeight: '700',
  },
  frontierHeading: {
    fontSize: FontSize.h1,
    fontWeight: '500',
    color: Color.primary,
    ...CommonProperties.p3,
    ...CommonProperties.mt3,
  },
  confirmationText: {
    color: Color.primary,
    textAlign: 'center',
    ...CommonProperties.p5,
  },
  loading: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Color.blurred,
  },
  rebookBox: {
    width: '100%',
    backgroundColor: Color.accent,
  },
  rebookText: {
    fontSize: FontSize.h3,
  },
  form: {
    width: '100%',
    maxWidth: 420,
  },
  submitButton: {
    ...CommonProperties.py3,
    ...CommonProperties.boxShadow,
  },
});
export default RebookScreen;
